/* istanbul ignore file */
/* tslint:disable */
import * as codec from 'purify-ts/Codec';
import { oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { CoursePermMap, GlobalPermMap } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function permission(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([
            GlobalPermMap,
            /* #__PURE__ */ codec.record(codecString, CoursePermMap),
        ]))),
    });
    return Object.freeze({
        /**
         * Get all the global permissions or all course permissions for all courses for the currently logged in user.
         *
         * @param arg The arguments to the function.
         * @param arg.type The type of permissions to get. This can be `global` or `course`. If `course` is passed this will return the permissions as if you have already paid, even if this is not the case. It will also not take any restrictions of this session into consideration.
         * @returns The returning object depends on the given `type`. If it was `global` a mapping between permissions name and a boolean indicating if the currently logged in user has this permissions is returned. If it was `course` such a mapping is returned for every course the user is enrolled in. So it is a mapping between course ids and permission mapping.
         */
        getAll: async ({ type, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/permissions/`, getAllResponse.v, undefined, {
                type,
            });
            return result;
        },
    });
}
